import React, { Component, PropTypes } from 'react';

import OutboundLink from 'components/outbound-link';
import Wrapper from 'components/wrapper';

import styles from './styles.module.css';
import TweenMax from 'gsap';

export default class ProjectIntro extends Component {
  static propTypes = {
    media: PropTypes.node,
    project: PropTypes.object,
  };

  componentDidMount(prevProps, prevState) {
    TweenMax.set(this.introLogo, { y: -400 });
    TweenMax.fromTo(this.introLogo, 3, { y: -400 }, { y: 0 });
  }
  render() {
    const { media, project } = this.props;

    const textStyle = {
      color: project.slug == 'incruizer' ? 'black' : 'white',
    };

    return (
      <Wrapper className={styles.cover}>
        <div className={styles.intro}>
          <h1 style={textStyle}>{project.title}</h1>
          <p style={({ fontSize: '25px' }, textStyle)}>
            {project.clientDescription || project.description}
          </p>
        </div>
        <div ref={c => (this.introLogo = c)} className={styles.media}>
          {media}
        </div>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ../components/project/intro/index.jsx